import React, {
  ReactElement,
  Ref,
  forwardRef,
  useContext,
  useRef,
} from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Dialog,
  DialogHandle,
  Form,
  FormCheckbox,
  FormHandle,
  FormTextField,
  UserContext,
  useEventCallback,
} from '@eas/common-web';
import { NamedSettingsContext } from '../context/named-settings-context';
import {
  CreateDialogProps,
  ParsedTableNamedSettings,
} from './table-named-settings-types';

export const CreateDialog = forwardRef(function CreateDialog(
  { onConfirm }: CreateDialogProps,
  dialogRef: Ref<DialogHandle> | undefined | null
) {
  const { hasPermission } = useContext(UserContext);
  const { adminPermission } = useContext(NamedSettingsContext);
  const ref = useRef<FormHandle<ParsedTableNamedSettings>>(null);

  const handleSubmit = useEventCallback((values: ParsedTableNamedSettings) => {
    onConfirm(values);
  });

  const handleSave = useEventCallback(() => {
    ref.current?.submitForm();
  });

  const hasAdminPermission = adminPermission && hasPermission(adminPermission);

  return (
    <Dialog
      ref={dialogRef}
      title={
        <FormattedMessage
          id="EAS_TABLE_NAMED_SETTINGS_DIALOG_TITLE_DETAIL"
          defaultMessage="Uložení nastavení"
        />
      }
      confirmLabel={
        <FormattedMessage
          id="EAS_TABLE_NAMED_SETTINGS_BTN_SAVE"
          defaultMessage="Uložit"
        />
      }
      onConfirm={handleSave}
    >
      {() => (
        <div style={{ width: 400 }}>
          <Form
            editing
            initialValues={{
              id: '',
              name: '',
              settings: {
                isTop: false,
                filtersState: [],
                columnsState: [],
                sorts: [],
                topOrder: 0,
                version: 1,
              },
              tag: '',
              shared: false,
            }}
            onSubmit={handleSubmit}
            ref={ref}
          >
            <FormTextField
              name="name"
              label={
                <FormattedMessage
                  id="EAS_TABLE_NAMED_SETTINGS_LABEL_FIELD_NAME"
                  defaultMessage="Název"
                />
              }
            />
            {hasAdminPermission && (
              <FormCheckbox
                name="shared"
                label={
                  <FormattedMessage
                    id="EAS_TABLE_NAMED_SETTINGS_LABEL_FIELD_SHARED"
                    defaultMessage="Sdílené"
                  />
                }
              />
            )}
          </Form>
        </div>
      )}
    </Dialog>
  );
}) as (p: CreateDialogProps & { ref?: Ref<DialogHandle> }) => ReactElement;
